import { render, staticRenderFns } from "./CommentVisibilitySelector.vue?vue&type=template&id=afe3868a"
import script from "./CommentVisibilitySelector.vue?vue&type=script&lang=ts"
export * from "./CommentVisibilitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports